export default "__VITE_ASSET__MUDP4jc8NhHDmzQ56_cGyQ__"